import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  chip: {
    margin: theme.spacing.unit,
  }
});

//TODO: implement flexGrow, issue with avatar not displaying left justified
class ChipClickable extends Component {
  render() {
    const { avatar, classes, label, handleClick } = this.props;

    return(
      <div className={classes.root}>
        <Chip
            avatar={
              avatar === undefined
              ? <Avatar>{label && label.slice(0,1).toUpperCase()}</Avatar>
              : avatar
            }
            label={label}
            className={classes.chip}
            onClick={handleClick}
        />
      </div>
    );
  }
}

ChipClickable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ChipClickable);



// WEBPACK FOOTER //
// ./src/components/Chips/ChipClickable.jsx